import { motion } from "framer-motion";

/**
 * Live HTML inside a photographed screen.
 *
 * The plates were generated with genuinely blank screens (founder's note in
 * tokens.js) so nothing is ever baked into an image. The rect is measured from
 * the plate in percentages, so it holds at every width — the image scales, the
 * overlay scales with it, and the two never drift apart.
 */
export const ScreenScene = ({ plate, rect, children, testid, tint }) => (
  <div
    className="relative mx-auto w-full select-none overflow-hidden rounded-xl border border-white/8"
    data-testid={testid}
  >
    <img src={plate} alt="" draggable={false} className="block w-full" />

    <div
      className="absolute"
      style={{
        left: `${rect.left}%`,
        top: `${rect.top}%`,
        width: `${rect.width}%`,
        height: `${rect.height}%`,
      }}
      data-testid={`${testid}-glass`}
    >
      {children}
      {/* the glass itself: a faint sheen and a vignette, so the overlay reads as
          something lit behind glass rather than a div pasted on a photograph */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "linear-gradient(158deg, rgba(255,255,255,0.075) 0%, rgba(255,255,255,0.02) 26%, rgba(255,255,255,0) 47%)",
          boxShadow: "inset 0 0 42px rgba(0,0,0,0.75)",
        }}
      />
    </div>

    {/* the room catches the light the screen is throwing */}
    <motion.div
      className="pointer-events-none absolute inset-0"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2.2, ease: "easeOut" }}
      style={{
        background: `radial-gradient(circle at ${rect.left + rect.width / 2}% ${
          rect.top + rect.height / 2
        }%, ${tint || "rgba(242,200,119,0.14)"} 0%, rgba(0,0,0,0) 46%)`,
        mixBlendMode: "screen",
      }}
    />
  </div>
);

/** Measured off /plates swDeskScreen (1536x1024). The monitor is straight-on. */
export const DESK_SCREEN = { left: 24.2, top: 29.4, width: 42.6, height: 32.2 };

/** Measured off swSofaScreen (1448x1086). The wall screen, straight-on. */
export const WALL_SCREEN = { left: 36.2, top: 26.0, width: 27.6, height: 21.8 };

export default ScreenScene;
